import React from 'react';

import { ReactActionDialogBodyProps } from '~commonInfra/dialogs/ReactActionDialog';
import { Messages } from '~src/codegen/Localize';
import { EditPoolNameField } from '~src/settings/dataconnect-settings/sections/dataConnectMultiPool/EditPoolNameField';

export type PropsForEditDataConnectPoolDialog = ReactActionDialogBodyProps<
  EditDataConnectPoolDialogProps,
  EditDataConnectPoolDialogState
>;

export type EditDataConnectPoolDialogProps = Readonly<{
  existingPoolNames: string[];
}>

export type EditDataConnectPoolDialogState = Readonly<{
  poolName: string;
  hasError: boolean;
}>

export function EditDataConnectPoolDialogBody(props: PropsForEditDataConnectPoolDialog) {
  const onPoolNameChange = (poolName: string) => {
    props.updateDialogState({ poolName });
  };
  const onHasErrorChange = (hasError: boolean) => {
    props.updateDialogState({ hasError });
  };

  return (
    <EditPoolNameField
      poolName={props.dialogState.poolName}
      onPoolNameChange={onPoolNameChange}
      hasError={props.dialogState.hasError}
      onHasErrorChange={onHasErrorChange}
      existingPoolNames={props.existingPoolNames}
      description={Messages.dataConnectSiteSettingsEditPoolDialogDescription()}
    />
  );
}
